<template>
  <header>
    <router-link :to="{ name: 'home' }" class="home_link">
      <img class="logo_left" src="../static/logo_home.svg" alt="Logo_home" >
    </router-link>
    <router-link :to="{ name: 'home' }">
      <div class="text">
        <p> <b>    aide-covid.grandlyon.com</b> </p>
      </div>
    </router-link>
    <div class="right">
      <div class="nav-toolbar" @click='stats("ClickHome")'>
        <router-link :to="{ name: 'home' }">Accueil</router-link>
      </div>
      <!--<div class="nav-toolbar" @click='stats("ClickSearch")'>
        <router-link id='list' :to="{ name: 'list', query: { cat: '1' } }">Les initiatives archivées</router-link>
      </div>-->
      <div class="nav-toolbar" @click='stats("Add_Initiative")'>
        <router-link :to="{ name: 'description' }">En savoir + sur la démarche</router-link>
      </div>
    </div>
  </header>
</template>

<script>

var _paq = window._paq || [];

export default {
    data: function() {
        return {
            menu_filter: "Accueil"
        }
    },
    methods: {
      stats: function(actionName) {
          _paq.push(["trackEvent", "HomePage", actionName]);
      }
  }
  }
</script>


<style scoped>
header {
  display: flex;
  align-items: center;
  padding: 0.5% 10% 0.2% 10%;
}

a {
  font-size: 90%;
  font-weight: bold;
  color: black;
  text-decoration: none;
  outline: 0;
}

.home_link{
  margin-right: 1%;
}

.logo_left{
  float: left;
}

.text p{
  text-align: left;
}

.right {
  display: flex;
  flex-grow: 1;
  justify-content:flex-end;
}

.nav-toolbar {
    margin: 0 5%
}

label {
    background-color: var(--very-light-grey);
}

a:hover{
  color: var(--medium-red);
}

.nav-toolbar .router-link-active#list {
  color: var(--medium-red);
  border-bottom: 2px solid var(--medium-red);
}

.nav-toolbar .router-link-exact-active {
  color: var(--medium-red);
  border-bottom: 2px solid var(--medium-red);
}


@media (max-width: 700px) {
  .text p{
    display: none;
  }
}

/* mobile */

@media (max-width: 600px) {
  header{
    padding: 0.5% 0;
  }

  .right {
    justify-content: space-around;
    margin-right: 10%
  }

  a {
    font-size: 3vw;
  }

  img{
    width: 50%;
  }
}

</style>
